import { useQuery } from "@tanstack/react-query";
import type { ProcessCatalogItem, ProcessCatalogResponse } from "common";
import { axios } from "@via/api/axios.tsx";

export const PROCESS_CATALOG_QUERY_KEY = [
  "processCatalog",
  "/api/v1/process/catalog",
] as const;

export const useProcessCatalog = () =>
  useQuery<ProcessCatalogItem[]>({
    queryKey: PROCESS_CATALOG_QUERY_KEY,
    queryFn: async () => {
      const response = await axios.get<ProcessCatalogResponse>(
        "/api/v1/process/catalog"
      );
      return response.data.data;
    },
  });
